import { SvgLogo } from "ui/svgs";
import clsx from "clsx";
import { useEffect, useRef, useState, memo } from "react";
import { formatMinute } from "lib/utils";
import { useService } from "pages/dashboard/alerts/service";

export type presetGuardPicType = {
  snapshotUrl: string;
  createdAt: number;
  eventId: string;
};

function ItemSlide(props: {
  data: presetGuardPicType;
  pause: boolean;
  isActive: boolean;
  setCurrentPicId?: (eventId: string) => void;
  onLoaded?: (eventId: string, src: string) => void;
}) {
  const { getCachedImg, setCachedImg } = useService();
  const { data, pause, isActive, setCurrentPicId, onLoaded } = props;
  const itemRef = useRef<HTMLDivElement>(null);
  const [imgSrc, setImgSrc] = useState<string>("");

  const [isVisible, setIsVisible] = useState<string | boolean>("");
  //console.log("enter ItemSlide", data.eventId, isVisible);
  useEffect(() => {
    console.log(
      "enter scrollIntoView",
      isActive,
      pause,
      isVisible,
      data.eventId,
    );
    if (!isActive || isVisible !== false) {
      return;
    }

    //if (document.fullscreenElement || !pause) {
    console.log("need scrollIntoView");
    itemRef.current?.scrollIntoView({
      inline: "start",
    });
    //}
  }, [isActive]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log("enter isIntersecting", entry.isIntersecting);
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 },
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, []);

  useEffect(() => {
    async function downloadImageAsBlob(imageUrl, retry = 0) {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error("Fail to download image");
        }

        const blob = await response.blob();
        setImgSrc(URL.createObjectURL(blob));
        setCachedImg(data.eventId, "presetGuardPic", blob);
      } catch (error) {
        if (retry >= 3) {
          onLoaded?.(data.eventId, "");
          console.error("error:", error);
          return;
        }
        downloadImageAsBlob(imageUrl, retry + 1);
      }
    }
    getCachedImg(data.eventId, "presetGuardPic").then((blobData) => {
      if (blobData) {
        setImgSrc(URL.createObjectURL(blobData));
      } else {
        downloadImageAsBlob(data.snapshotUrl);
      }
    });
  }, [data]);

  return (
    <div
      key={data.eventId}
      style={{ scrollSnapAlign: "start" }}
      onClick={() => setCurrentPicId?.(data.eventId)}
      ref={itemRef}
    >
      <div
        className={clsx(
          "relative rounded-xl flex-shrink-0 aspect-video w-[140px] cursor-pointer border-2 overflow-hidden",
          isActive ? " border-[#3E83F6]" : "border-transparent",
        )}
      >
        {isActive && (
          <div className="absolute  top-0 left-0 w-full h-full bg-[#3E83F6] bg-opacity-15" />
        )}
        {imgSrc ? (
          <img
            src={imgSrc}
            alt="Camera Snapshot"
            className="aspect-video rounded-lg select-none"
            onLoad={() => onLoaded?.(data.eventId, imgSrc)}
            onError={() => onLoaded?.(data.eventId, "")}
            draggable="false"
          />
        ) : (
          <div className="aspect-video bg-zinc-100 h-full rounded-lg flex flex-col items-center justify-center">
            <SvgLogo width="24" className="fill-neutral-400 mb-3 w-8" />
          </div>
        )}

        <div className="absolute z-[-1] top-0 left-0 w-full h-full bg-white flex items-center border justify-center rounded-xl">
          <SvgLogo width="28" className="fill-zinc-400" />
        </div>
        <p className="absolute bottom-1 right-1 w-[57px] h-[22px] bg-[#222222] bg-opacity-70 rounded-lg text-white text-xs text-center leading-[22px]">
          {formatMinute(+data?.createdAt)}
        </p>
      </div>
    </div>
  );
}

export default memo(ItemSlide);
